var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "container-content",
            class: { error: _vm.errors.has(_vm.getFieldName("Documento")) }
          },
          [
            _c("app-label", {
              attrs: {
                label: "Tipo de documento:",
                required: _vm.validateDocumentos
              }
            }),
            _c(
              "el-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "input select",
                class: {
                  erro: _vm.errors.has(_vm.getFieldName("Tipo de documento"))
                },
                attrs: {
                  "data-vv-validate-on": "change",
                  placeholder: "Selecione o documento...",
                  name: "Tipo de documento",
                  "data-vv-scope": _vm.scopeFields,
                  disabled: _vm.loading
                },
                on: { change: _vm.handleTipoChanged },
                model: {
                  value: _vm.tipoDocumento,
                  callback: function($$v) {
                    _vm.tipoDocumento = $$v
                  },
                  expression: "tipoDocumento"
                }
              },
              _vm._l(_vm.tiposDocumentos, function(item) {
                return _c("el-option", {
                  key: item.codigo,
                  attrs: { label: item.descricao, value: item.codigo }
                })
              }),
              1
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has(
                      _vm.getFieldName("Tipo de documento")
                    ),
                    expression: "errors.has(getFieldName('Tipo de documento'))"
                  }
                ],
                staticClass: "help erro"
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.errors.first(_vm.getFieldName("Tipo de documento"))
                  )
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "container-content" },
          [
            _c("app-label", {
              attrs: { label: "Documento:", required: _vm.validateDocumentos }
            }),
            _c(
              "el-input",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "input",
                class: { erro: _vm.errors.has(_vm.getFieldName("Documento")) },
                attrs: {
                  id: "fileName",
                  "data-vv-validate-on": "change",
                  name: "Documento",
                  "data-vv-scope": _vm.scopeFields,
                  readonly: "readonly"
                },
                model: {
                  value: _vm.fileName,
                  callback: function($$v) {
                    _vm.fileName = $$v
                  },
                  expression: "fileName"
                }
              },
              [
                _c("el-button", {
                  attrs: {
                    slot: "append",
                    icon: "el-icon-search",
                    disabled: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.callEventClick()
                    }
                  },
                  slot: "append"
                })
              ],
              1
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has(_vm.getFieldName("Documento")),
                    expression: "errors.has(getFieldName('Documento'))"
                  }
                ],
                staticClass: "help erro"
              },
              [_vm._v(_vm._s(_vm.errors.first(_vm.getFieldName("Documento"))))]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "button-anexo",
            class: { error: _vm.errors.has(_vm.getFieldName("Documento")) }
          },
          [
            _c("app-button", {
              attrs: {
                tipo: "success",
                icone: "far fa-paperclip",
                titulo: "Anexar",
                size: "large",
                method: "anexaDocumento",
                loading: _vm.loading
              },
              on: {
                anexaDocumento: function($event) {
                  return _vm.addDocumento()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { md: 24, lg: 24, xl: 24 } }, [
            _c("input", {
              ref: "eventoClick",
              staticStyle: { display: "none" },
              attrs: {
                type: "file",
                id: _vm.scope,
                multiple: "false",
                accept: _vm.validExtensions
              },
              on: { change: _vm.setDocument }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e26dcdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e26dcdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppUploadDocumentosAnexar.vue
// module id = null
// module chunks = 